export default "__VITE_ASSET__BoET3wEZ__"